/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/button-has-type */
// TODO: Remove eslint-disable
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import classNames from "classnames";
import ImgixClient from "imgix-core-js";
import { Preview, Close } from "@svg";
import { Carousel } from "@common";
import { Image } from "@ui";
import { detect } from "@utils";

const PreviewLink = ({ children, className, textClass, pdf }) => {
  const hasWindow = detect.browser().window;
  const client = new ImgixClient({
    domain: process.env.GATSBY_IMGIX_DOMAIN,
    secureURLToken: process.env.GATSBY_IMGIX_TOKEN,
  });
  const hoverStates = hoverState => {
    let classes = "";
    // eslint-disable-next-line array-callback-return
    hoverState.map(value => {
      classes += ` hover:${value}`;
    });
    return classes;
  };

  if (hasWindow) {
    Modal.setAppElement(document.getElementById("#App"));
  }

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [screenSlides, setScreenSlides] = useState(false);
  const pagesMax = [];
  const openModal = () => {
    setModalIsOpen(true);
  };
  const afterOpenModal = () => {
    // setModalIsOpen(true);
  };
  const closeModal = () => {
    document.getElementsByClassName("ReactModal__Overlay")[0].style.opacity = 0;
    setTimeout(() => {
      setModalIsOpen(false);
    }, 333);
  };
  const getSlides = load => {
    if (!load) return;
    const pages = [];
    // see if image exists function
    const doesImageExist = url => {
      setIsLoading(true);
      const http = new XMLHttpRequest();
      http.open("GET", url, false);
      http.send();
      return http.status === 200;
    };
    // iterate through numbers until there are no pages left
    [...Array(50).keys()].some(i => {
      pagesMax.push({ i });
      // build test image
      const testImage = client.buildURL(pdf, {
        page: i + 1,
        w: 1,
        h: 1,
      });

      // does the image exist?
      const imageExists = doesImageExist(testImage);
      if (imageExists) {
        // add to array if it does
        pages.push({
          image: {
            url: pdf,
            params: {
              page: i + 1,
              bg: "ffffff",
            },
          },
        });
      } else {
        // return if we've reached the last page
        return true;
      }
    });
    setScreenSlides(pages);
    setIsLoading(false);
  };
  const ModalContent = load => {
    if (screenSlides != null && load) {
      if (screenSlides.length > 1) {
        return <Carousel content={screenSlides} />;
      }
      if (screenSlides.length === 1) {
        return <Image src={screenSlides[0].image.url} />;
      }
    }
    return null;
  };
  // change state on scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
        setTimeout(() => {
          getSlides(isScrolled);
        }, 2222);
      }
    };

    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      // clean up the event handler when the component unmounts
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  return (
    <div data-active={scrolled}>
      {isLoading && (
        <div className="flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="fill-current stroke-current w-full h-full animate-spin text-blue"
            viewBox="0 0 64 64"
            style={{ maxWidth: "20px", marginRight: "9px" }}
          >
            <path
              fillRule="evenodd"
              d="m43.1430912 44.1196402c.4952348.0003078.8967265.4014431.8967265.8958584v11.646159c0 .4947232-.4018001.8961662-.8973433.8961662h-35.79227734c-.49585152 0-.89734323-.401443-.89734323-.8961662v-35.7330511c0-.4947232.40149171-.8958584.89734323-.8958584h11.74255344c.4955432 0 .8973433.4011352.8973433.8958584v22.2819375c0 .4947232.4018.8958584.8970348.8961663zm-16.6998352-15.2419068v-7.6803694-.2687575c0-.4947232.4014917-.8958584.8973432-.8958584h2.1314215c.680254 0 1.3487901.0504882 2.0046833.1409976 2.2356489.3087787 4.3115646 1.1227476 6.105326 2.3273847 1.6016498 1.0756458 2.976651 2.4609938 4.0426701 4.0679975 1.1946074 1.8009524 1.9966658 3.8811294 2.2883794 6.1198518.0807917.618481.1267382 1.247429.1267382 1.8874598v2.2051662c0 .4947231-.4021085.8961662-.8976516.8958585l-15.8018753-.006773c-.4955431-.0003078-.8970348-.401443-.8970348-.8961662zm36.2104208-14.4294771-14.7093368 8.4783299c-.4021084.2318149-.9164618.1197556-1.1810393-.261369-1.4295819-2.0620136-3.2181011-3.8561932-5.27644-5.292953-.3795977-.2650633-.4896842-.7767185-.2584101-1.1769301l8.5889007-14.85154652c.3453693-.59723892-.0863423-1.34378758-.7773891-1.34378758h-5.3785088c-.3203917 0-.6167308.17055173-.7773891.44792919l-7.673364 13.26886331c-.1985873.3432585-.5994623.5076531-.9861525.4177594-1.5279504-.3546491-3.1181907-.54398-4.7525271-.54398h-2.1314215c-.4958515 0-.8973432-.4011352-.8973432-.8961662v-11.79854731c0-.49472317-.4021085-.89585839-.8976517-.89585839h-4.6578589c-.4955432 0-.8976516.40113522-.8976516.89585839v11.79854731c0 .495031-.4018001.8961662-.8973433.8961662h-18.19540726c-.49554316 0-.89734324.4011353-.89734324.8958584v48.6174035c0 .495031.40180008.8961662.89734324.8961662h48.69798506c.4955431 0 .8976516-.4011352.8976516-.8961662v-18.0877195c0-.4947232.4018001-.8958584.8973432-.8958584h11.7123337c.4955431 0 .8973432-.4014431.8973432-.8961662v-4.6501516c0-.495031-.4018001-.8961662-.8973432-.8961662h-11.7123337c-.4955431 0-.8973432-.4011352-.8973432-.8958584v-2.205474c0-1.5980759-.1810105-3.1548993-.5214459-4.6516908-.0881925-.3854346.0946682-.7822599.4375705-.9799029l13.1422239-7.5750829c.2775288-.1600847.4486716-.4556256.4486716-.7757949v-5.369609c0-.6899033-.747786-1.1209004-1.3463232-.7761027z"
            />
          </svg>
        </div>
      )}
      {!isLoading && (
        <button
          type="button"
          className={`${textClass} ${className} transition cursor-pointer font-bold antialiased group items-center inline-flex inline-link`}
          onClick={() => {
            openModal();
          }}
        >
          {children}
          <Preview className="ml-6 group-hover:ml-8 transition" />
        </button>
      )}
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        // false positive
        ariaHideApp={false}
        className={classNames({
          "w-full h-full no-bg": true,
        })}
        style={{}}
      >
        <button
          type="button"
          className="p-4 fixed top-0 right-0"
          onClick={closeModal}
        >
          <Close />
        </button>
        <ModalContent load={scrolled} />
      </Modal>
    </div>
  );
};

PreviewLink.defaultProps = {
  className: "",
  textClass: "text-teal",
  children: {},
};

PreviewLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  textClass: PropTypes.string,
  pdf: PropTypes.string.isRequired,
};

export default React.memo(PreviewLink);
